import { useState } from "react";
import { Container, Box, Typography, Tabs, Tab } from "@mui/material";
import BlacklistAdmin from "./BlacklistAdmin";
import StatsAdmin from "./StatsAdmin";
import UsersAdmin from "./UsersAdmin"; // à créer

const ADMIN_TABS = [
  { key: "blacklist", label: "Blacklist" },
  { key: "stats", label: "Stats" },
  { key: "users", label: "Utilisateurs" }, // nouvelle tab
];

function AdminPage() {
  const [tab, setTab] = useState("blacklist");

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        marginTop: { xs: "16px", md: "32px" },
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: "border-box",
        width: "100%",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          padding: { xs: "16px", sm: "24px", md: "32px" },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "100%",
          maxWidth: "900px",
          mx: "auto",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontSize: { xs: "1.5rem", md: "2rem" } }}
        >
          Admin
        </Typography>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          centered
          sx={{
            mb: 2,
            ".MuiTabs-flexContainer": { flexWrap: "wrap" },
          }}
        >
          {ADMIN_TABS.map((t) => (
            <Tab
              key={t.key}
              value={t.key}
              label={t.label}
              sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}
            />
          ))}
        </Tabs>
        {/* Affichage conditionnel des sous-pages */}
        {tab === "blacklist" && <BlacklistAdmin />}
        {tab === "stats" && <StatsAdmin />}
        {tab === "users" && <UsersAdmin />} {/* nouvelle page */}
      </Box>
    </Container>
  );
}

export default AdminPage;
